import router from "@/router";

const ADMIN = "Super Administrador";
const GESTOR_INFANTIL = "Gestor Ensino Infantil";
const CENTRAL_MATRICULA = "CENTRAL DE MATRICULAS";

export const AUTH_TYPE = {
  LOGIN: "LOGIN",
  REFRESH: "REFRESH",
};

export function getAuthToken(api) {
  const token = localStorage.getItem(`token-${api}`);
  return token && `Bearer ${token}`;
}

export function getRefreshToken(api) {
  return localStorage.getItem(`refreshToken-${api}`);
}

export function atualizaTokens({ token, refreshToken }, api = "erudio") {
  localStorage.setItem(`token-${api}`, token);
  localStorage.setItem(`refreshToken-${api}`, refreshToken);
}

export function armazenarCredenciaisErudio(
  credenciais,
  autenticacao = AUTH_TYPE.LOGIN
) {
  if (autenticacao === AUTH_TYPE.LOGIN) {
    localStorage.setItem("token-erudio", credenciais.token);
    localStorage.setItem("refreshToken-erudio", credenciais.refreshToken);
    localStorage.setItem(
      "atribuicoes",
      JSON.stringify(credenciais.usuario.atribuicoes)
    );
    return;
  }

  atualizaTokens(credenciais, "erudio");
}

export function isAdmin() {
  const userRole = JSON.parse(localStorage.getItem("user")).role;
  return userRole === ADMIN;
}

export function isGestor() {
  const userRole = JSON.parse(localStorage.getItem("user")).role;
  return userRole === CENTRAL_MATRICULA || userRole === GESTOR_INFANTIL;
}

export function getUser() {
  const user = localStorage.getItem("user");
  return user ? JSON.parse(user) : null;
}

export function getAtribuicoes() {
  const atribuicoes = localStorage.getItem("atribuicoes");
  return atribuicoes ? JSON.parse(atribuicoes) : null;
}

export function getAtribuicaoAtiva() {
  return JSON.parse(localStorage.getItem("atribuicaoAtiva"));
}

export function setAtribuicaoAtiva(atribuicao) {
  localStorage.setItem("atribuicaoAtiva", JSON.stringify(atribuicao));
  router.currentRoute.path !== "/" && router.push("/");
  location.reload();
}

export function isAuthenticated() {
  return !!localStorage.getItem("token-vaga-integral");
}

export function logout() {
  localStorage.clear();
  window.location.assign("/");
}
